import React, { useEffect } from 'react';
import { Box } from 'rebass';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bool, node, func, object } from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { CaretLeft, CaretDown, CaretUp } from '@nike/nike-design-system-icons';
import { H1 } from '../../components/containers/Headers';
import { VelocityDropdown } from '../../animation';
import { getAdminHeaderOpenState } from '../selectors';
import { setHeaderIsOpen } from '../actions';

const PageHeader = ({
  title,
  HeaderContent,
  alwaysShowHeader,
  isOpen,
  setHeaderIsOpen,
  linkBack: { url, linkTitle } = {}
}) => {
  useEffect(() => {
    if (alwaysShowHeader && !isOpen) setHeaderIsOpen(true);
  }, [alwaysShowHeader]);

  return (
    <div className='header border-bottom bg-white p6-sm pr5-sm pl5-sm z2'>
      <div className='d-sm-flx flx-jc-sm-sb'>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {url && linkTitle && (
            <Box mb='18px' ml='-5px'>
              <Link to={url}>
                <ButtonStyled
                  type='button'
                  appearance='text'
                  background='light'
                  size='large'
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CaretLeft size='s' />
                  <span className='ml1-sm'>{linkTitle}</span>
                </ButtonStyled>
              </Link>
            </Box>
          )}
          <div className='d-sm-flx'>
            <H1 className='flx-as-sm-fs pr4-sm'>{title}</H1>

            {HeaderContent && !alwaysShowHeader && (
              <ButtonStyled appearance='text' size='small' onClick={() => setHeaderIsOpen(!isOpen)}>
                {isOpen ? <CaretUp data-testid='caret_up' /> : <CaretDown data-testid='caret_down' />}
              </ButtonStyled>
            )}
          </div>
        </div>
      </div>
      {HeaderContent && (
        <VelocityDropdown show={alwaysShowHeader || isOpen}>
          <hr style={{ marginBottom: '13px', marginTop: '13px' }} />
          <div className='d-sm-flx flx-dir-sm-r flx-ac-sm-c flx-jc-sm-sb'>{HeaderContent}</div>
        </VelocityDropdown>
      )}
    </div>
  );
};

PageHeader.defaultProps = {
  HeaderContent: null,
  alwaysShowHeader: false,
  linkBack: {}
};

PageHeader.propTypes = {
  HeaderContent: node,
  alwaysShowHeader: bool,
  isOpen: bool.isRequired,
  linkBack: object,
  setHeaderIsOpen: func.isRequired,
  title: node.isRequired
};

const mapStateToProps = state => ({
  isOpen: getAdminHeaderOpenState(state)
});

export default connect(mapStateToProps, { setHeaderIsOpen })(PageHeader);
